import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { Union } from 'src/app/pap-creation/pap-dto/pap-dto';

@Component({
  selector: 'app-union-verification',
  templateUrl: 'union-verification.component.html',
  styleUrls: ['./union-verification.component.less', '../../../../shared/common.less'],
})

export class UnionVerificationComponent implements OnInit {
  @Input() union: Union;
  @Input() index: number;
  @Output() unionChange = new EventEmitter<Union>();
  @Output() deleteAtIndex = new EventEmitter<number>();

  needPap: boolean = undefined;

  constructor(
    private router: Router,
  ) {}

  removeAt(index: number) {
    this.deleteAtIndex.emit(index);
  }
  
  onUnionChange() {
    this.unionChange.emit(this.union);
  }

  goToPollCreation() {
    this.router.navigate(['/poll-creation']);
  }
  
  ngOnInit(): void {
  }
}
